module.exports = __webpack_public_path__ + "static/img/a03.a7ca1546.jpg";